import type {ReactElement} from 'react';
import {useRef} from 'react';
import type {AiChatLoginSectionProps} from './ai-chat-login-section.types';
import {AI_CHAT_LOGIN_SECTION_CONTENT} from './ai-chat-login-section.types';
import styles from './ai-chat-login-section.module.scss';
import {NewFeatureBadge} from '@Components/login-signup-testimony/components/new-feature-badge/new-feature-badge';
import {NewFeatureBadgeColorType} from '@Components/login-signup-testimony/components/new-feature-badge/new-feature-badge.types';
import {Text, TextSize} from '@Components/text';

export function AiChatLoginSection({className = '', textClassName = ''}: AiChatLoginSectionProps): ReactElement {
  const randomisedIndex = useRef(Math.floor(Math.random() * 3));
  const {heading1LangKey, heading2LangKey, imgURL} = AI_CHAT_LOGIN_SECTION_CONTENT[randomisedIndex.current] ?? AI_CHAT_LOGIN_SECTION_CONTENT[0];

  const getExtraImgClassForIndex = (): string => {
    if (randomisedIndex.current === 0) {
      return styles.aiImgCapped;
    }

    return '';
  };

  return (
    <div className={`flex-v-row flex-1 spacing-m-t-12 spacing-p-t-10 ${styles.aiChatContentContainer} ${className}`}>
      <div className={`flex-v-row`}>
        <NewFeatureBadge colorType={NewFeatureBadgeColorType.PREMIUM} />
        <Text val={window.i18next.t(heading1LangKey)} className={`${styles.heading} ${textClassName} spacing-m-t-5 content-body-white`} size={TextSize.LG} bold />
        <Text val={window.i18next.t(heading2LangKey)} className={`${styles.heading} ${textClassName} content-body-white _unmargin`} size={TextSize.LG} bold />
      </div>
      <img src={imgURL} className={`${styles.aiChatImg} ${getExtraImgClassForIndex()} _full-width`} alt="PosterMyWall AI" width={300} height={300} />
    </div>
  );
}
